export default "__VITE_ASSET__CYEWGF7c__"